import EmailFormSection from 'features/requirements/sections/requirementFormTypes/emailForm/EmailFormSection';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RolesChecker from '../components/RolesChecker';

type Props = {}

const ChangeEmailPage = (props: Props) => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");
  const tLabels = useTranslation("customer\\customer").t;

  return (
    <RolesChecker enabledRoles="Contributor">
      <Header title={t("changeEmailPage.title")} 
        includeBreadcrumbs
        links={[
          { text: t("customer.title"), to: "/customer" }
        ]} 
      />
      <ModuleContent>
        <EmailFormSection 
          useOutsideOfRequirements  
          sendButtonTitle={tLabels("changeEmailPage.changeEmail")}
        />
      </ModuleContent>
    </RolesChecker>
  )
}

export default ChangeEmailPage;